export default "__VITE_ASSET__9b91fdad__"